import {
  getCities
} from "./chunk-YO6XT5IM.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/city/cities.ts
import { useQuery } from "@tanstack/react-query";
var useGetCities = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["cities", props],
    queryFn: () => getCities(props)
  }, options));
};

export {
  useGetCities
};
//# sourceMappingURL=chunk-UPHE75MB.mjs.map